import { render, staticRenderFns } from "./ElectricalDamageDetailsSection.vue?vue&type=template&id=e70a8b28"
import script from "./ElectricalDamageDetailsSection.vue?vue&type=script&lang=ts"
export * from "./ElectricalDamageDetailsSection.vue?vue&type=script&lang=ts"
import style0 from "./ElectricalDamageDetailsSection.vue?vue&type=style&index=0&id=e70a8b28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports